var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warning-message-container"},[_c('div',{staticClass:"ic-warning"}),_c('span',{staticClass:"warning-message",domProps:{"innerHTML":_vm._s(_vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }